import React from 'react'
import Popover from '@material-ui/core/Popover'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import useStyles from './BarcodeToolTip.styles'
import clsx from 'clsx'

function BarcodeToolTip(props) {
  const classes = useStyles()
  const [anchorEl, setAnchorEl] = React.useState(null)

  function handlePopoverOpen(event) {
    setAnchorEl(event.currentTarget)
  }

  function handlePopoverClose() {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)

  return (
    <div className="float-right float-right-with-margin">
      <Button
        className={clsx('bg-asset-header', classes.button)}
        classes={{
          root: props.tooltipInfo.colorTransparent ? classes.btnRoot : '',
        }}
        aria-owns={open ? 'mouse-over-popover' : undefined}
        aria-haspopup="true"
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
        style={{backgroundColor: 'transparent'}}
      >
        {props.tooltipInfo.image}
      </Button>
      <Popover
        // id="mouse-over-popover"
        className={classes.popover}
        classes={{
          paper: classes.paper,
        }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
        disableScrollLock={true}
      >
        <Typography>{props.tooltipInfo.title}</Typography>
      </Popover>
    </div>
  )
}

export default BarcodeToolTip
